@if (isMapLoaded()?.isLoaded) {
  <div class="or-position-absolute or-w-100-pc z-index-999 or-bg-shade or-pb-12-px">
    <lib-filters [showDistanceFilter]="false" [showAlertsFilter]="true"></lib-filters>
  </div>

  <div
    class="or-position-absolute z-index-999 or-mx-20-px"
    [ngClass]="isiOS ? 'location-banner-position-ios' : 'location-banner-position'">
    <lib-location-button (clicked)="onLocationBannerClicked()"></lib-location-button>
  </div>
}

<div #map class="map-container"></div>
